// src/redux/slices/clientMasterSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../config/axiosConfig";

export const updateClientDetails = createAsyncThunk(
  "clientMaster/updateClientDetails",
  async ({ leadId, updatedData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/client-details/update/${leadId}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// DELETE client
export const deleteClientDetails = createAsyncThunk(
  "clientMaster/deleteClientDetails",
  async (leadId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `/client-details/delete/${leadId}`
      );
      return { leadId, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const clientMasterSlice = createSlice({
  name: "clientMaster",
  initialState: {
    loading: false,
    error: null,
    success: false,
    updatedClient: null,
    deletedClientId: null,
  },
  reducers: {
    resetClientMasterState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.updatedClient = null;
      state.deletedClientId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // UPDATE
      .addCase(updateClientDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateClientDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedClient = action.payload;
      })
      .addCase(updateClientDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DELETE
      .addCase(deleteClientDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteClientDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.deletedClientId = action.payload.leadId;
      })
      .addCase(deleteClientDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetClientMasterState } = clientMasterSlice.actions;
export default clientMasterSlice.reducer;
